export const mutations = {
  MtUpdateEmi(state, message) {
    state.emi = message;
  },
  socialLogin(state, obj) {
    state.email = obj.email;
    state.fullname = obj.fullname;
    state.token = obj.google_id;
    state.socialLogin = true;
    router.push({
      name: "entrepreneur_register",
      query: { email: obj.email, fullname: obj.fullname },
    });
  },
  async loginSuccess(state, userModel) {
    state.userModel = userModel;
  },
  MutationSetMerchantList(state, merchantList) {
    state.merchantList = merchantList;
  },
  MutationSetDemoOrganize(state, demoOrganize) {
    state.demoOrganize = demoOrganize;
  },
  MutationUserDetailForDisplay(state, userDetailList) {
    if (!(state.otherUserList && state.otherUserList.length > 0)) {
      state.otherUserList = [];
    }
    for (let userDetail of userDetailList) {
      let otherUser = state.otherUserList.find((x) => x.userId === userDetail.userId);
      if (otherUser && otherUser.userId === userDetail.userDetail) {
        var index = state.otherUserList.indexOf(otherUser);
        state.otherUserList.splice(index, 1);
      }
      state.otherUserList.push(userDetail);
    }
  },
  MutationSetMerchantListLoadingStatus(state, status) {
    state.merchantListLoadingStatus = status;
  },
  MutationAllUserDetailForDisplayByMerchantId(state, userDetailList) {
    state.userListInMerchant = [];
    if (!(state.otherUserList && state.otherUserList.length > 0)) {
      state.otherUserList = [];
    }
    for (let userDetail of userDetailList) {
      let otherUser = state.otherUserList.find((x) => x.userId === userDetail.userId);
      if (otherUser && otherUser.userId === userDetail.userDetail) {
        var index = state.otherUserList.indexOf(otherUser);
        state.otherUserList.splice(index, 1);
      }
      state.otherUserList.push(userDetail);
      state.userListInMerchant.push(userDetail);
    }
  },

  MutationSetLoginstatus(state, status) {
    state.loginstatus = status;
  },
  MutationSetGetUserInfoByUserIdLoadingStatus(state, status) {
    state.getUserInfoByUserIdLoadingStatus = status;
  },
  MutationsSelectMerchant(state, selectMerchant) {
    state.selectMerchant = selectMerchant;
  },
  MutationsSetSelectMerchantLodingStatus(state, status) {
    state.selectMerchantLodingStatus = status;
  },
  MutationsGet2ndLoginLodingStatus(state, status) {
    state.get2ndLoginLodingStatus = status;
  },
  MutationsGet2ndLogin(state, is2ndLogin) {
    state.is2ndLogin = is2ndLogin;
  },
  MutationsSet2ndLoginLodingStatus(state, status) {
    state.set2ndLoginLodingStatus = status;
  },
  MutationsSetRefreshTokenExpirationLodingStatus(state, status) {
    state.refreshTokenExpirationLodingStatus = status;
  },
  MutationSetFavoriteMerchantList(state, favoriteMerchantList) {
    state.getFavoriteMerchantList = favoriteMerchantList;
  },
  MutationSetFavoriteMerchantListLoadingStatus(state, status) {
    state.getFavoriteMerchantListLoadingStatus = status;
  },
  MutationSetUpdateFavoriteMerchantLoadingStatus(state, status) {
    state.updateFavoriteMerchantLoadingStatus = status;
  },
  MutationSetDeleteFavoriteMerchantLoadingStatus(state, status) {
    state.deleteFavoriteMerchantLoadingStatus = status;
  },
  MutationSetDeleteMerchantLoadingStatus(state, status) {
    state.deleteMerchantLoadingStatus = status;
  },
  MutationSetCheckIsCreatedMerchantNotSampleLoadingStatus(state, status) {
    state.checkIsCreatedMerchantNotSampleLoadingStatus = status;
  },
  MutationSetIsCreatedMerchantNotSample(state, isCreatedMerchantNotSample) {
    state.isCreatedMerchantNotSample = isCreatedMerchantNotSample;
  },
  MutationSetMerchantModelByIdLoadingStatus(state, status) {
    state.merchantModelByIdLoadingStatus = status;
  },
  MutationSetMerchantModelList(state, merchantModel) {
    state.merchantModelListForMap.set(merchantModel.merchantId, merchantModel);
  },
};
